import CallButton from "components/CallButton";

/**
 * Not Found View
 */
export default function NotFoundView() {
  return (
    <div className="mx-auto max-w-lg px-4 py-16 text-center">
      <h1 className="mb-4 font-serif text-3xl text-soil">Quote Not Found</h1>
      <p className="mb-8 text-lg text-soil/70">
        We couldn't find this quote. It may have been removed or the link may be
        incorrect.
      </p>
      <CallButton variant="inline" />
    </div>
  );
}
